import styled from 'styled-components';

export const NamesBoxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;

  @media ${(props) => props.theme.device.tabletL} {
    display: block;
  }
`;

export const NamesBox = styled.div`
  margin: 11px 0 16px;
  border-radius: 8px;
  padding: 0 12px 8px;
  background: ${(props) => props.theme.colors.white};
  max-width: 100%;
  height: 320px;
  overflow-y: auto;

  .no-results {
    padding-top: 20px;
  }
  @media ${(props) => props.theme.device.tabletL} {
    width: 100%;
  }
`;

export const FiltersWrapper = styled.div`
  margin-bottom: 24px;

  @media ${(props) => props.theme.device.tabletL} {
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

export const NameWrapper = styled.div`
  padding: 12px 0;
  border-bottom: 1px solid #e3e3e3;
  background-color: ${(props) => props.theme.colors.white};

  &.select-all {
    border-color: #646464;
    position: sticky;
    top: 0;
    z-index: 1;
    padding-top: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .consumer {
    padding-left: 16px;
    border-left: 1px solid ${(props) => props.theme.colors.border};
  }

  label {
    color: ${(props) => props.theme.colors.textPrimary};
    span {
      color: #646464;
    }
  }
`;
